<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>

import { lysConfigApi, getAuthApi } from '@/api/basic'
import { getUserProjectApi } from '@/api/point'

export default {
  name: 'lysApp',
  data () {
    return {}
  },
  mounted () {
    const user = localStorage.getItem('lys_user')
    if (user !== 'undefined' && user !== null) {
      const userinfo = JSON.parse(user)
      userinfo.isLogin = true
      this.$store.commit('setUserInfo', userinfo)
    }
    const project = localStorage.getItem('lys_project')
    console.log('app-mounted---', project)
    if (project !== 'undefined' && project !== null) {
      this.$store.commit('setProject', JSON.parse(project))
    }
    this.lysConfig()
  },
  methods: {
    lysConfig () {
      const project = localStorage.getItem('lys_project')
      lysConfigApi().then((res) => {
        this.$store.commit('setLysConfig', res.data)
        if (this.$store.state.user.isLogin) {
          // 获取用户最近的项目
          if (!project) {
            getUserProjectApi().then((proRes) => {
              if (proRes.data) {
                this.$store.commit('setProject', proRes.data)
              }
            })
          }
          // 获取用户授权的选点流程
          getAuthApi().then((rules) => {
            if (rules.data) {
              this.$store.commit('setRules', rules.data)
            }
            this.$reslove() // 其他页面，等待此方法执行后，再执行，使用async await
          })
        } else {
          this.$reslove()
        }
      }).catch((err) => {
        console.log('getCaptchaApi-err', err)
      })
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0;
  margin: 0;
}

.el-cascader__search-input::placeholder {
  //color: #333333;
  font-size: 14px;
}

.el-cascader__tags {
  font-size: 14px;
  max-height: 290px;
  //position: absolute;
  //left: 0;
  //right: 0.15625rem;
  //top: 50%;
  //transform: translateY(-50%);
  //display: flex;
  //flex-wrap: nowrap;
  //line-height: normal;
  //text-align: left;
  //box-sizing: border-box;
}
</style>
